<template>
    <div class="pa-4 px-6">
        <v-alert type="error" v-if="notAuthorized">
            {{ $t('forms.not_authorized') }}
        </v-alert>
        <v-alert type="error" v-if="networkError">
            {{ $t('globals.network_error') }}
        </v-alert>

        <EmailsCustomizationForm
            ref="form"
            v-model="localCompany"
            @submit="submit"
            :disabled="loading"
            :isFormValid.sync="isFormValid"
        >
            <template #submit>
                <div class="d-flex justify-end">
                    <v-btn type="submit" color="primary" depressed class="action-button" :loading="loading" :disabled="!isFormValid">
                        {{ $t('actions.save') }}
                    </v-btn>
                </div>
            </template>
        </EmailsCustomizationForm>
    </div>
</template>

<script>
import EmailsCustomizationForm from '@/components/forms/EmailsCustomizationForm'
import HasErrorHandlerMixin from '@/mixins/HasErrorHandlerMixin'
import Company from '@/models/Company'
import { mapGetters } from 'vuex'

export default {
    name: 'EmailsCustomization',
    components: {
        EmailsCustomizationForm,
    },
    mixins: [ HasErrorHandlerMixin ],
    data: vm => ({
        localCompany: new Company,
        
        loading: false,
        notAuthorized: false,
        isFormValid: false,
        networkError: false
    }),
    created() {
        this.cloneCompany()
    },
    mounted() {
        this.$emit('update-is-completed', this.$refs.form.validate())
    },
    methods: {
        cloneCompany() {
            this.localCompany = new Company(this.$lodash.cloneDeep(this.company))

            // Para evitar que todos os atributos do json sejam atualizados juntos com os desse form, é
            // é preciso especificar aqui todos os atributos utilizados nesse form, e somente eles
            this.localCompany.json = {
                custom_emails: this.$lodash.get(this.localCompany.json, 'custom_emails', {
                    successful_transaction: {},
                    customer_level_updated_period_update: {},
                    customer_level_updated_renovation: {},
                    customer_level_updated_setup: {},
                    customer_level_updated_simple: {},
                    customer_level_updated_system_updated: {},
                    promotion_triggered: {},
                    vouchers_received: {},
                }),
            }
        },
        async submit(company) {
            this.networkError = false
            this.loading = true
            this.notAuthorized = false

            let res = await company.update(['json'])
                .catch(this.preErrorHandler)
            this.loading = false

            if (!res)
                return

            await this.$store.dispatch('company/fetchData')
            this.cloneCompany()
            this.$emit('update-is-completed', this.isFormValid)

            this.$bus.$emit('message', this.$t('views.companies.parent.Personalize.alerts.success'), 'success')
        },

        preErrorHandler(e) {
            if (e.message == 'Network Error')
                this.networkError = true
            
            let status = this.$lodash.get(e, 'response.status')

            if (status == 403) {
                this.notAuthorized = true
            }

            this.errorHandler(e)
        },
    },
    computed: {
        ...mapGetters({
            company: 'company/state',
        }),
    },
}
</script>
